export var CommentStatus;
(function (CommentStatus) {
    CommentStatus["PENDING"] = "pending";
    CommentStatus["APPROVED"] = "approved";
    CommentStatus["REJECTED"] = "rejected";
    CommentStatus["SPAM"] = "spam";
})(CommentStatus || (CommentStatus = {}));
//# sourceMappingURL=comment.interface.js.map